import { Component, OnInit, Input, SimpleChange } from '@angular/core';
import { RecSearchService } from '../../../rec-search/rec-search-service'
import { CityTownVM } from '../../viewmodels/ISearchService';
//import { SelectedCityTown } from '../../viewmodels/SelectedCityTown';
//import { element } from '@angular/core/src/render3';
import { CityTownCIF } from '../../../shared/viewmodels/UtilityObj';
import { Store, select } from '@ngrx/store';
//import { AppState } from './../../../app.state';
import { Router } from '@angular/router';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
//import { UntypedFormGroup, FormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-city-town-ex',
  templateUrl: './city-town-ex.component.html',
  styleUrls: ['./city-town-ex.component.css']
})
export class CityTownEXComponent implements OnInit {


  public utilityobj: CityTownCIF;
  public message: any;
  public error: any;
  public toggleCheck: boolean = false;
  public isChecked: boolean = false;
  public selectedTowns: string = "All Towns";
  //public cityTownLabel: string = "Select Towns"
 // public selectedcities: SelectedCityTown[] = [];
  //public form: UntypedFormGroup;

  constructor(private service: RecSearchService, private store: Store<AppState>) {
  }

  ngOnInit() {
    this.utilityobj = new CityTownCIF();

    this.store.select(getRegSearchState).subscribe(data => this.message = data);

      if (this.message != undefined && this.message.city != undefined && this.message.city.citytowns != null && this.message.city.citytowns.length != 0) {
        this.utilityobj.citytowns = this.message.city.citytowns[0].citytowns;
        var selectedTowns = this.utilityobj.citytowns.filter(function (value) { return value["isChecked"] == true; });
        var townsString = "";
        selectedTowns.forEach(t => townsString = `${townsString} ${t.townName}`);
        this.selectedTowns = townsString;
        if (townsString.length === 0)
          this.selectedTowns = "All Towns";
        else if(townsString.length > 50)
         this.selectedTowns = this.selectedTowns.substring(0, 50) + '...';
      }

      else {
        this.getResults();
      }

  }

  ngOnChanges(changes: SimpleChange) {
    console.log(`Changes Fired: ${JSON.stringify(changes)}`);
  }

  getResults() {

    this.service.getCityTown().subscribe(
      data => {

        this.utilityobj.citytowns = data
        this.utilityobj.citytowns.forEach(function (value) {
          value["isChecked"] = false;

        }

        );

      },
      error => { this.error = error }
    );

  }
  citySelected(city) {
    //console.log(`citySelected fired event: ${JSON.stringify(city)}`);

    this.utilityobj.citytowns = this.utilityobj.citytowns.map((val) => ({
      ...val
    }));

    var selectedTowns = this.utilityobj.citytowns.filter(function (value) { return value["isChecked"] == true; });

    //console.log(`selctedTowns: ${JSON.stringify(selectedTowns)}`);
    var townsString = "";
    selectedTowns.forEach(t => townsString = `${townsString} ${t.townName}`);
    this.selectedTowns = townsString;
    if (townsString.length === 0)
      this.selectedTowns = "All Towns";
    else if (townsString.length > 50)
      this.selectedTowns = this.selectedTowns.substring(0, 50) + '...';

  }
  checkAll(event) {

      //this.utilityobj.citytowns.forEach(function (val) {
      //  val["isChecked"] = false;
      //});

    this.utilityobj.citytowns = this.utilityobj.citytowns.map((val) => ({
      ...val,
      isChecked: false,
    }));

      this.isChecked = false;
      this.selectedTowns = "All Towns";

  }
 

}




